<template>
    <div 
        class="zs-dash-grid-item"
        :data-gs-id="id"
        :data-gs-x="x"
        :data-gs-y="y"
        :data-gs-w="w"
        :data-gs-h="h"
        :data-gs-min-w="minW"
        :data-gs-min-h="minH"
        :data-gs-max-w="maxW"
        :data-gs-max-h="maxH"
        :data-gs-no-resize="noResize"
        :data-gs-no-move="noMove"
        :data-gs-locked="locked"
        :data-gs-auto-position="autoPosition"
    >
        <slot></slot>
    </div>
</template>

<script setup>
import { inject, onMounted } from 'vue'

const props = defineProps({
    // Widget identifier
    id: {
        type: String,
        default: () => `widget-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`
    },
    // Grid position
    x: {
        type: Number,
        default: undefined
    },
    y: {
        type: Number,
        default: undefined
    },
    // Widget size
    w: {
        type: Number,
        default: 2
    },
    h: {
        type: Number,
        default: 2
    },
    // Size constraints
    minW: {
        type: Number,
        default: undefined
    },
    minH: {
        type: Number,
        default: undefined
    },
    maxW: {
        type: Number,
        default: undefined
    },
    maxH: {
        type: Number,
        default: undefined
    },
    // Behavior flags
    noResize: {
        type: Boolean,
        default: false
    },
    noMove: {
        type: Boolean,
        default: false
    },
    locked: {
        type: Boolean,
        default: false
    },
    autoPosition: {
        type: Boolean,
        default: true
    }
})

// Access parent grid methods
const dashGrid = inject('dashGrid', null)

// Expose methods that can be called from parent
defineExpose({
    id: props.id,
    remove: () => {
        if (dashGrid) {
            dashGrid.removeWidget(props.id)
        }
    },
    update: (options) => {
        if (dashGrid) {
            dashGrid.updateWidget(props.id, options)
        }
    }
})
</script>

<style scoped>
.zs-dash-grid-item {
    width: 100%;
    height: 100%;
}
</style>
